import dji from './dji';
import mavlink from './mavlink';

const messageSet = {
  dji,
  mavlink,
};

export default messageSet;
